import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
  },
  checked: {},
  label: {
    fontSize: 14,
    lineHeight: 1.5,
  },
  hidden: {
    display: 'none',
    '&:checked + span': { background: theme.palette.primary.main },
    '&:checked + span:after': {
      content: 'no-open-quote',
      display: 'block',
      margin: '2px 0px 0px 7px',
      width: 5,
      height: 10,
      border: 'solid white',
      borderWidth: '0 2px 2px 0',
      transform: 'rotate(45deg)',
    },
  },
  spanCheckbox: {
    display: 'inline-block',
    position: 'relative',
    width: 20,
    height: 20,
    marginRight: 10,
    verticalAlign: 'middle',
    background: 'white left top no-repeat',
    border: '1px solid #979797',
    borderRadius: 3,
    cursor: 'pointer',
    '&:focus': {
      outline: 0,
    },
  },
  error: {
    borderColor: theme.palette.error.main,
  },
}));

const Checkbox: React.FC<any> = ({ label, checked, onChange, inputRef, name, error = false }) => {
  const classes = useStyles();
  return (
    <FormControlLabel
      className={classes.root}
      control={
        <span onChange={onChange}>
          <input type="checkbox" checked={checked} className={classes.hidden} onChange={() => onChange} name={name} />
          <span
            role="button"
            className={clsx([classes.spanCheckbox, error && classes.error])}
            tabIndex={0}
            aria-label="Checkbox"
          />
        </span>
      }
      label={label}
      classes={{
        label: classes.label,
      }}
      ref={inputRef}
    />
  );
};

export default Checkbox;
